export default __webpack_public_path__ + "static/media/ToyotaType-Book.d55cbe77.ttf";